
import Vue, { defineComponent, getCurrentInstance, onMounted } from 'vue';
import mainEmpty from '@/components/empty/index.vue';
import { genWebDidAndSessionId, getQuery, isPwa, genCheckPwaParams } from '@/common/utils';
import { sendLog, immediateSendLog, getKwaiLog } from '@/common/radar';

export default defineComponent({
    components: {
        mainEmpty,
    },
    layout(ctx) {
        return ctx.$pwaLayout || 'default';
    },
    setup() {
        const { proxy } = getCurrentInstance() as { proxy: Vue };
        const handleLog = () => {};
        onMounted(() => {
            const { webDid, sessionId } = genWebDidAndSessionId();
            const { pwa_source } = getQuery();
            const country = proxy?.$store?.state?.startup?.countryInfo;
            immediateSendLog({
                type: 'pv',
                name: 'PWA_SWITCH_GP',
                value: {
                    share_chain: window.location.href,
                    session_id: sessionId,
                    country,
                    web_did: webDid,
                    pwa_source,
                    pwa_install_source: localStorage.getItem('cachePwaSource'),
                    page_source: 'profile',
                    open_mode: isPwa() ? 'desktop' : 'other',
                    check_pwa_params: genCheckPwaParams(),
                },
            });
        });
        return {
            handleLog,
        };
    },
});
